import { render, staticRenderFns } from "./GiftCodeDialog.vue?vue&type=template&id=c184d43c&scoped=true"
import script from "./GiftCodeDialog.vue?vue&type=script&lang=js"
export * from "./GiftCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./GiftCodeDialog.vue?vue&type=style&index=0&id=c184d43c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c184d43c",
  null
  
)

export default component.exports